export type Permission = { id: string; key: string; name: string };
export type Continent = { id: string; code: string; name: string };
export type Country = { id: string; code: string; name: string; continentId?: string | null };
export type SalesAdminUser = {
  id: string;
  name: string;
  email: string;
  role: string;
  active: boolean;
  geographicScope?: string;
  permissionAssignments?: Array<{ permission: Permission }>;
  continentAssignments?: Array<{ continent: Continent }>;
  countryAssignments?: Array<{ country: Country }>;
};

export const geographicAccessLabel = (user: SalesAdminUser) => {
  if (user.geographicScope === 'GLOBAL') return 'Tüm Dünya';
  if (user.geographicScope === 'CONTINENT') return user.continentAssignments?.map((item) => item.continent.name).join(', ') || 'Kıta seçilmemiş';
  return user.countryAssignments?.map((item) => item.country.name).join(', ') || 'Ülke seçilmemiş';
};
